export default __webpack_public_path__ + "static/media/wuyeOne.653e239c.png";